import styled from  'styled-components';
import { Modal } from 'react-bootstrap';

const BoldFont = 'Rubik-Bold';

const StyledBody = styled(Modal.Body)`
  padding: 0 !important;
`;

const StyledTitle = styled(Modal.Title)`
  font-family: Rubik-Medium !important;
  text-align: left !important;
  color: rgb(0, 92, 135) !important;
  width: 50% !important;
  font-size: 18px !important;
  >div{
    display: flex;
    justify-content: flex-end;
  >img{
    width: 20px;
    height: 20px;
  }
}
  font-family: Rubik-Medium !important;
`;


const StyledTitleNew = styled(Modal.Title)`
  font-family: Lato !important;
  text-align: left !important;
  color: #184A61 !important;
  width: 50% !important;
  font-size: 18px !important;
  font-weight:700 !important;
  line-height:24px;
  >div{
    display: flex;
    justify-content: flex-end;
  >img{
    width: 20px;
    height: 20px;
  }
}
  font-family: Lato!important;
`;

const DeviceContainer = styled.div`
  width: 100%;
  height: 75px;
  ${'' /* border-bottom: 1px solid #e2e2e4; */}
  padding: 0 20px;
  display: table;
  
   .firstCard {
    width: 50%;
    display: table-cell;
    vertical-align: middle;
  }

  @media (max-width: 500px) {
    padding: 5vw;
    > div {
      &:first-child {
        width: 70%;
      }
    }
  }

  @media (max-width: 321px) {
    padding: 3vw;
  }
`;




const DeviceContainerNew = styled.div`
  width: 100%;
  height: 48px;
  ${'' /* border-bottom: 1px solid #e2e2e4; */}
  padding: 0 20px;
  display: table;
  
  > div {
    width: 50%;
    display: table-cell;
    vertical-align: middle;
  }

  > div:last-child {
    text-align: right;   /* 👈 FIX: pushes switch to flex-end */
  }

  @media (max-width: 500px) {
    padding: 5vw;
    > div {
      &:first-child {
        width: 70%;
      }
    }
  }

  @media (max-width: 321px) {
    padding: 3vw;
  }
`;

const RolesContainer = styled.div`
  width: 100%;
  height: 75px;
  border-top: ${({border}) => border ? '' : '1px solid #e2e2e4'};
  padding: 0 5vw;
  display: table;
  
  @media (max-width: 500px) {
    padding: 5vw;
    > div {
      &:first-child {
        width: 70%;
      }
    }
  }

  @media (max-width: 321px) {
    padding: 3vw;
  }
`;

const NameContainer = styled.div`
  width: ${({width}) => width ? width : '50%'};
  display: table-cell;
  vertical-align: middle;
`;

const LogoWrapper = styled.div`
  display: inline-block;
  padding-left: 12px;
  margin-top:12px;
    
  > div {
    font-size: 14px;
    text-transform: capitalize;
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #184A61;
    font-family: Lato;
  }
`;

const LinkedStatus = styled.span`
  font-size: 13px;
  font-family: Lato;
  color: ${(props) => props.isLinked ? '#DA6C74' : '#EFEFEF'};
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  width: 48px;
  height: 48px;
  float: left;
  border:0.2px solid #BDBDBD;
  border-radius:50%
  
  > img {
    ${'' /* width: 100%; */}
    width: 48px;
    height: 48px;
    float: left;
    border-radius:50%
  }
`;

const CustomLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  margin-bottom: 0;
  ${'' /* left: calc(100% - 6vw); */}

  @media (max-width: 500px) {
    left: calc(100% - 60px);
  }
  
  > input {
    display: none;
  }
  
  > input:checked + .slider {
    background-color: #DA6C74;
  }

  > input:focus + .slider {
    box-shadow: 0 0 1px #DA6C74;
  }
  
  > input:checked + .slider:before {
    background-color:#F8F8F8;
    -webkit-transform: translateX(16px);
    -ms-transform: translateX(16px);
    transform: translateX(16px);
  }
`;

const CustomCheckbox = styled.input`
  cursor: ${({ disabled }) => disabled ? 'not-allowed !important' : 'pointer'};
  
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #EFEFEF;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 34px;
  
  &:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 2px;
    background-color: #BDBDBD;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%;
  }
  cursor: ${({ disabled }) => disabled ? 'not-allowed !important' : 'pointer'};
`;

const ButtonContainer = styled.div`
  margin: 20px 0 30px 0;
  text-align: center;
`;

const SaveButton = styled.button`
  background-color: #159fc9;
  border: 1px solid #159fc9;
  color: white;
  white-space: nowrap;
  padding: 10px 80px;
  font-size: 14px;
  line-height: 1.428571429;
  border-radius: 30px;
  text-transform: uppercase;
  font-family: ${BoldFont};
  
  &:focus, &:active, &:hover {
    outline: none;
  }
`;

const ClosePopUp = styled.div`
width: 50%;
display: flex;
justify-content: flex-end;
>img{
  width: 20px;
  height: 20px;
  position: relative;
  cursor: pointer;
}
`;

const CloseIcon = styled.div`
    display: flex;
    justify-content: flex-end;
    position: relative;
    bottom: 25px;
`;

const StyledModal = styled(Modal)`
  .modal-dialog { 
    .modal-header {
      border-bottom: 0px;
    }
    .modal-content{
      float: ${({width}) => width && 'left'};
      ${'' /* width: 600px; */}
      width: ${({isWidth}) => isWidth ? isWidth : "600px"};
      margin-left:-50px;
    }
    @media (min-width: 700px){
      width:${({width}) => width};
    }
  }
  .reward-modal-header {
    text-align: right;
    color: #999;
    padding: 5px 15px;
    .close-icon {
      cursor: pointer;
    }
  }
 .deviceText{
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  margin-left:16px;
  margin-bottom:16px;
 }


`;




const StyledModalNew = styled(Modal)`
  .modal-dialog { 
    .modal-header {
      border-bottom: 0px;
    }
    .modal-content{
      border-radius:12px;
      float: ${({width}) => width && 'left'};
      ${'' /* width: 600px; */}
      width: ${({isWidth}) => isWidth ? isWidth : "600px"};
      margin:auto;
    }
    @media (min-width: 700px){
      width:${({width}) => width};
    }
  }
  .reward-modal-header {
    text-align: right;
    color: #999;
    padding: 5px 15px;
    .close-icon {
      cursor: pointer;
    }
  }
 .deviceText{
     color: var(--Font-Color-on-Light-theme-500, #184A61);
     font-family: Lato;
     font-size: 16px;
     font-style: normal;
     font-weight: 400;
     line-height: 20px; 
     margin-left:16px;
     margin-bottom:16px;
 }


`;

export {StyledModalNew, DeviceContainer,DeviceContainerNew, StyledBody, StyledTitle,StyledTitleNew, LogoWrapper, ImageContainer, CustomLabel, CustomCheckbox, Slider, LinkedStatus, SaveButton, ButtonContainer, RolesContainer, NameContainer, CloseIcon, ClosePopUp, StyledModal };

